import { ExperiencePerformanceTypes } from './platform-client/core/experience/experience-types';
export var UFOGlobalEventStreamEventType;

(function (UFOGlobalEventStreamEventType) {
  UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
  UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
  UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})(UFOGlobalEventStreamEventType || (UFOGlobalEventStreamEventType = {}));

export var PageVisibleState;

(function (PageVisibleState) {
  PageVisibleState["VISIBLE"] = "visible";
  PageVisibleState["HIDDEN"] = "hidden";
  PageVisibleState["MIXED"] = "mixed";
})(PageVisibleState || (PageVisibleState = {}));

export var PageLoadMetrics;

(function (PageLoadMetrics) {
  PageLoadMetrics["fmp"] = "fmp";
  PageLoadMetrics["tti"] = "tti";
})(PageLoadMetrics || (PageLoadMetrics = {}));

export var PageSegmentLoadMetrics;

(function (PageSegmentLoadMetrics) {
  PageSegmentLoadMetrics["fmp"] = "fmp";
  PageSegmentLoadMetrics["tti"] = "tti";
})(PageSegmentLoadMetrics || (PageSegmentLoadMetrics = {}));

export var InteractionMetrics;

(function (InteractionMetrics) {
  InteractionMetrics["response"] = "response";
  InteractionMetrics["result"] = "result";
})(InteractionMetrics || (InteractionMetrics = {}));

export var CustomMetrics;

(function (CustomMetrics) {
  CustomMetrics["duration"] = "duration";
})(CustomMetrics || (CustomMetrics = {}));

export var SUBSCRIBE_ALL = '__SUBSCRIBE_ALL__';
export var FMP_MARK = 'fmp';
export var INLINE_RESPONSE_MARK = 'inline-response';